import { useState } from 'react';
import { CmmFile } from '../../../shared/types/cmmReport.ts';
import { useCmmFileSelect } from '../../hooks/useCmmFileSelect.ts';
import { FileSource } from '../../services/cmm-import/types.ts';
import { ProtocolDraft } from '../../types/sharedTypeImpl.ts';
import { trpc } from '../../utils/trpc/trpc.ts';
import { testImportCmmFiles } from './testImportCmmFiles.ts';
import { TestImportFile } from './types.ts';


interface Props {
    protocol: ProtocolDraft;
}

export function useTestCmmImport({
    protocol,
}: Props) {
    const [positionsDialogState, setPositionsDialogState] = useState<TestImportFile | null>(null);


    const { data: cmmConfigs } = trpc.cmmConfigs.get.useQuery({ sort: { order: 1 } });
    const { data: cmmEquipments } = trpc.equipments.getAllCustom.useQuery({ type: 'cmm/vmm' });

    const {
        isManualImportClicked,
        filesDialogState,
        handleManualImportClick,
        handleLocalFilesSelected,
        handleFilesDialogSubmit,
        handleFilesDialogCancel,
    } = useCmmFileSelect({
        partName: protocol.partName,
        onFilesSelected,
    });

    async function onFilesSelected(valueSource: FileSource, cmmReports: CmmFile[]) {
        if (!cmmConfigs) {
            alert('Failed to load CMM configurations');
            return;
        }

        try {
            const files = cmmReports.map((it) => it.file);
            setPositionsDialogState(null);
            const result = await testImportCmmFiles(protocol, cmmConfigs, cmmEquipments, files);
            setPositionsDialogState(result);
        } catch (error) {
            alert('Failed to fetch CMM reports');
        }
    }


    return {
        isManualImportDisabled: isManualImportClicked,
        filesDialogState,
        positionsDialogState,
        handleManualImportClick,
        handleFilesDialogSubmit,
        handleFilesDialogCancel,
        handleLocalFilesSelected,
        handlePositionsDialogClose: () => setPositionsDialogState(null),
    }
}
